import React, { useContext } from "react";
import { Button, Col, Container, Input, Label, Row } from "reactstrap";
import {
  Border,
  TextAlign,
  fontFamily,
  fontWeight,
} from "../../../../constant";
import DetailsContext from "../../../context/DetailsContext/DetailsContext";
import { IconButton } from "@material-ui/core";
import Dividers from "../../../common/divider";
import { Zoom, toast } from "react-toastify";
import { Switch } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { UploadCloud } from "react-feather";
import ByteCardBuilderContext from "../../../context/BytecardBilderContext/ByteCardBuilderContext";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import { OpenModalCommonFunc } from "../../../utils";
import { Cases, DELETE_CONFIRM } from "../../../constant";
import {
  delete_Image_Permanent,
  delete_Multi_Image_Permanent,
} from "../apis/SliderApi/SliderApi";
import ProductImageUploadPopup from "../../../Modals/imageUploade/productImageUploadPopup";
import { SketchPicker } from "react-color";
import CommonColor from "../../../common/CommonColor";
import CustomStyle from "../../../common/CustomStyle";

const SettingDetailsPerentPopup = (props) => {
  const {
    isEdit,
    settingFormData,
    setSettingFormData,
    boxSection,
    setBoxSection,
    backImageToggle,
    setBackImageToggle,
    isBackgroundColor,
    setIsBackgroundColor,
  } = useContext(DetailsContext);
  const {
    allPopupState,
    setAllPopupState,
    crop,
    setCrop,
    completedCrop,
    setCompletedCrop,
    scale,
    rotate,
  } = useContext(ByteCardBuilderContext);
  const { imageUpload, handleSubmitSetting } = props;
  const { setLoaderShow } = useContext(LoaderContext);

  /**
   * input value change
   * @param {event} e
   */

  const handleChangeOnlyTextSection = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".only-text-section"]: {
          ...prev[".only-text-section"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeOnlyTextSectionSectionBgImage = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".only-text-section.bg-image::before"]: {
          ...prev[".only-text-section.bg-image::before"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeOnlyTextSectionTitleArea = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".only-text-section .section-title-area"]: {
          ...prev[".only-text-section .section-title-area"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeOnlyTextSectionSubTitle = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".only-text-section .section-title-area .section-subtitle"]: {
          ...prev[".only-text-section .section-title-area .section-subtitle"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeOnlyTextSectionTitle = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".only-text-section .section-title-area .section-title"]: {
          ...prev[".only-text-section .section-title-area .section-title"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeOnlyTextContentP = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".only-text-section .only-text-content p"]: {
          ...prev[".only-text-section .only-text-content p"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeOnlyTextContentInfoList = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".only-text-section .only-text-content.info-list"]: {
          ...prev[".only-text-section .only-text-content.info-list"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeOnlyTextContentInfoListLi = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".only-text-section .only-text-content .info-list li"]: {
          ...prev[".only-text-section .only-text-content .info-list li"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeOnlyTextContentOrderList = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".only-text-section .only-text-content .order-list"]: {
          ...prev[".only-text-section .only-text-content .order-list"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeOnlyTextContentOrderListLi = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".only-text-section .only-text-content .order-list li"]: {
          ...prev[".only-text-section .only-text-content .order-list li"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeOnlyTextContentOrderListLiBefore = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".only-text-section .only-text-content .order-list li:before"]: {
          ...prev[
            ".only-text-section .only-text-content .order-list li:before"
          ],
          [name]: value,
        },
      };
    });
  };
  const handleChangeCustomStyle = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const resetHandler = () => {
    setSettingFormData({
      ".only-text-section": {
        padding: "100px 0",
        "background-color": { r: 255, g: 255, b: 255, a: 100 },
      },
      image: "",
      ".only-text-section.bg-image": {},
      ".only-text-section.bg-image::before": {},
      ".only-text-section .section-title-area": {
        "margin-bottom": "50px",
      },
      ".only-text-section .section-title-area .section-subtitle": {
        "font-size": "16px",
        "font-weight": "600",
        color: { r: 255, g: 73, b: 124, a: 100 },
        "background-color": { r: 255, g: 73, b: 124, a: 0.2 },
        padding: "5px 20px",
        p1: "5px",
        p2: "20px",
        "border-radius": "15px",
        "margin-bottom": "15px",
      },
      ".only-text-section .section-title-area .section-title": {
        "font-size": "44px",
        "font-weight": "600",
        color: { r: 0, g: 0, b: 0, a: 100 },
      },
      ".only-text-section .only-text-content p": {
        "margin-bottom": "20px",
        "line-height": "1.6",
        "font-size": "18px",
      },
      ".only-text-section .only-text-content.info-list": {
        "margin-bottom": "30px",
      },
      ".only-text-section .only-text-content .info-list li": {
        "margin-bottom": "15px",
        "font-size": "18px",
      },
      ".only-text-section .only-text-content .order-list": {
        "margin-bottom": "30px",
      },
      ".only-text-section .only-text-content .order-list li": {
        "padding-left": "25px",
        "margin-bottom": "15px",
        "font-size": "18px",
      },
      ".only-text-section .only-text-content .order-list li:before": {
        "font-family": "FontAwesome",
        top: "3px",
        color: { r: 255, g: 73, b: 124, a: 100 },
      },
      detailsSectionId: "",
      custom: "",
    });
    setBoxSection(false);
    setBackImageToggle(false);
    setIsBackgroundColor(true);
  };

  /**
   * delete image permanently
   */
  const deleteImagePermanent = async () => {
    try {
      let confirmation = window.confirm(DELETE_CONFIRM);
      if (confirmation) {
        setLoaderShow(true);
        let formData = {
          fileName: settingFormData?.[".only-text-section.bg-image"]?.[
            "background-image"
          ]
            .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
            .pop(),
        };
        const { data } = await delete_Multi_Image_Permanent(formData);
        if (data.status === 200) {
          toast.success(data.message, {
            autoClose: 1000,
            position: "top-center",
          });
          setSettingFormData({
            ...settingFormData,
            ".only-text-section.bg-image": { "background-image": "" },
          });
          setLoaderShow(false);
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message, {
        autoClose: 1000,
        transition: Zoom,
      });
      setLoaderShow(false);
    }
  };

  /**
   * image reupload
   */
  const reupload = () => {
    setSettingFormData((prev) => {
      return {
        ...prev,
        image: "",
      };
    });
  };
  return (
    <>
      <Container className="mb-5">
        <Row>
          <Col sm="12" xl="12">
            <div className="mt-4 d-flex flex-column justify-content-center position-relative">
              <div
                className="d-flex justify-content-between position-sticky"
                style={{ top: "100px", background: "white", zIndex: 999 }}
              >
                <h6>{isEdit ? "Edit" : "Add New"}</h6>

                <div className="d-flex gap-2">
                  <Button onClick={resetHandler}>Reset</Button>
                  <Button onClick={() => handleSubmitSetting(true)}>
                    Restore
                  </Button>
                  <Button
                    onClick={() => handleSubmitSetting(null, false)}
                    color="success"
                  >
                    Save & View
                  </Button>
                </div>
              </div>
              <Row className="mt-4">
                <h4 className="mb-3">Make change in Main section</h4>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Padding (default : 100)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="padding"
                    type="number"
                    placeholder="padding"
                    value={settingFormData?.[".only-text-section"]?.["padding"]
                      ?.split(" ")[0]
                      ?.replace(/px/g, "")}
                    onChange={(e) => handleChangeOnlyTextSection(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="4 mb-3">
                  <div className="d-flex align-items-center">
                    <Label htmlFor="validationCustom03">
                      {isBackgroundColor
                        ? "Add Background Color"
                        : "Remove Background Color"}
                    </Label>
                    <Switch
                      checked={isBackgroundColor}
                      inputProps={{ "aria-label": "controlled" }}
                      onChange={(e) => {
                        setIsBackgroundColor(e.target.checked);
                        setSettingFormData((prev) => {
                          if (e.target.checked) {
                            if (boxSection) {
                              return {
                                ...prev,
                                [".only-text-section"]: {
                                  "background-color": {
                                    r: 255,
                                    g: 255,
                                    b: 255,
                                    a: 100,
                                  },
                                  padding:
                                    settingFormData?.[".only-text-section"]?.[
                                      "padding"
                                    ],
                                  width: settingFormData?.[
                                    ".only-text-section"
                                  ]?.["width"]?.replace("rem)", ""),
                                  margin: settingFormData?.[
                                    ".only-text-section"
                                  ]?.["margin"]
                                    ?.split(" ")[0]
                                    ?.replace(/px/g, ""),
                                  "border-radius": settingFormData?.[
                                    ".only-text-section"
                                  ]?.["border-radius"]?.replace(/rem/g, ""),
                                },
                              };
                            } else {
                              return {
                                ...prev,
                                [".only-text-section"]: {
                                  "background-color": {
                                    r: 255,
                                    g: 255,
                                    b: 255,
                                    a: 100,
                                  },
                                  padding:
                                    settingFormData?.[".only-text-section"]?.[
                                      "padding"
                                    ],
                                },
                              };
                            }
                          } else {
                            if (boxSection) {
                              return {
                                ...prev,
                                [".only-text-section"]: {
                                  padding:
                                    settingFormData?.[".only-text-section"]?.[
                                      "padding"
                                    ],
                                  width: settingFormData?.[
                                    ".only-text-section"
                                  ]?.["width"]?.replace("rem)", ""),
                                  margin: settingFormData?.[
                                    ".only-text-section"
                                  ]?.["margin"]
                                    ?.split(" ")[0]
                                    ?.replace(/px/g, ""),
                                  "border-radius": settingFormData?.[
                                    ".only-text-section"
                                  ]?.["border-radius"]?.replace(/rem/g, ""),
                                },
                              };
                            } else {
                              return {
                                ...prev,
                                [".only-text-section"]: {
                                  padding:
                                    settingFormData?.[".only-text-section"]?.[
                                      "padding"
                                    ],
                                },
                              };
                            }
                          }
                        });
                      }}
                    />
                  </div>
                  {isBackgroundColor && (
                    <CommonColor
                      color={
                        settingFormData?.[".only-text-section"]?.[
                          "background-color"
                        ]
                      }
                      setSettingFormData={setSettingFormData}
                      className={".only-text-section"}
                      classProperty={"background-color"}
                      label={"Select Background Color"}
                    />
                  )}
                </Col>
                <p>{"Box Section : convert your section to Box section"}</p>
                <div>
                  <Switch
                    checked={boxSection}
                    inputProps={{ "aria-label": "controlled" }}
                    onChange={(e) => {
                      setBoxSection(e.target.checked);
                      setSettingFormData((prev) => {
                        return {
                          ...prev,
                          ".only-text-section": {
                            padding: settingFormData?.[".only-text-section"]?.[
                              "padding"
                            ]
                              ?.split(" ")[0]
                              ?.replace(/px/g, ""),
                            "background-color":
                              settingFormData?.[".only-text-section"]?.[
                                "background-color"
                              ],
                            width: e.target.checked ? "10" : "",
                            margin: e.target.checked ? "0" : "",
                            "border-radius": e.target.checked ? "3" : "",
                          },
                        };
                      });
                    }}
                  />
                </div>
                {boxSection && (
                  <>
                    <Col md="4 mb-3">
                      <Label htmlFor="validationCustom03">
                        {"Width (Default : 10)"}
                      </Label>
                      <Input
                        className="form-control"
                        name="width"
                        type="number"
                        placeholder="width"
                        value={settingFormData?.[".only-text-section"]?.[
                          "width"
                        ]?.replace("rem)", "")}
                        onChange={(e) => handleChangeOnlyTextSection(e)}
                        style={{ borderRadius: "0", color: "black" }}
                      />
                    </Col>
                    <Col md="4 mb-3">
                      <Label htmlFor="validationCustom03">
                        {"Margin (Default : 0)"}
                      </Label>
                      <Input
                        className="form-control"
                        name="margin"
                        type="number"
                        placeholder="margin"
                        value={settingFormData?.[".only-text-section"]?.[
                          "margin"
                        ]
                          ?.split(" ")[0]
                          ?.replace(/px/g, "")}
                        onChange={(e) => handleChangeOnlyTextSection(e)}
                        style={{ borderRadius: "0", color: "black" }}
                      />
                    </Col>
                    <Col md="4 mb-3">
                      <Label htmlFor="validationCustom03">
                        {"Border Radius (Default : 3)"}
                      </Label>
                      <Input
                        className="form-control"
                        name="border-radius"
                        type="number"
                        placeholder="Border Radius"
                        value={settingFormData?.[".only-text-section"]?.[
                          "border-radius"
                        ]?.replace(/rem/g, "")}
                        onChange={(e) => handleChangeOnlyTextSection(e)}
                        style={{ borderRadius: "0", color: "black" }}
                      />
                    </Col>
                  </>
                )}
              </Row>
              <hr />
              <Row className="mt-4">
                <Col md="12 mb-3">
                  <h4 className="mb-3">Add Background Image in section</h4>

                  <p>do you want to upload Background image</p>
                  <Switch
                    checked={backImageToggle}
                    inputProps={{ "aria-label": "controlled" }}
                    onChange={(e) => {
                      setBackImageToggle(e.target.checked);
                      setSettingFormData((prev) => {
                        if (e.target.checked) {
                          return {
                            ...prev,
                            image: "",
                            ".only-text-section.bg-image": {},
                            ".only-text-section.bg-image::before": {
                              "background-color": { r: 0, g: 0, b: 0, a: 0.8 },
                            },
                          };
                        } else {
                          return {
                            ...prev,
                            image: "",
                            ".only-text-section.bg-image": {},
                            ".only-text-section.bg-image::before": {},
                          };
                        }
                      });
                    }}
                  />
                  {backImageToggle && (
                    <>
                      {" "}
                      <Col md="6 mb-3">
                        <Dividers divide="IMAGE" />
                        <p className="mb-4">
                          File type required JPG, PNG (1905px X 1049px)
                        </p>
                      </Col>
                      <Row>
                        <Col md="4 mb-3">
                          <div
                            className="aj-uploader d-flex flex-wrap  justify-content-center  align-items-center"
                            style={{ cursor: "pointer" }}
                          >
                            {!settingFormData?.[
                              ".only-text-section.bg-image"
                            ]?.["background-image"] && (
                              <span
                                onClick={() =>
                                  OpenModalCommonFunc(
                                    Cases.PRODUCT_UPLOAD,
                                    setAllPopupState
                                  )
                                }
                              >
                                <UploadCloud />
                              </span>
                            )}

                            {settingFormData?.[".only-text-section.bg-image"]?.[
                              "background-image"
                            ] && (
                              <img
                                src={
                                  settingFormData?.[
                                    ".only-text-section.bg-image"
                                  ]?.["background-image"] || ""
                                }
                                alt=""
                                style={{
                                  width: "85%",
                                  height: "90px",
                                  objectFit: "contain",
                                  position: "absolute",
                                }}
                                onClick={() => deleteImagePermanent()}
                              />
                            )}
                            {settingFormData?.[".only-text-section.bg-image"]?.[
                              "background-image"
                            ] && (
                              <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="close"
                                style={{
                                  color: "red",
                                  position: "absolute",
                                  top: "-22px",
                                  left: "1px",
                                }}
                                onClick={() => deleteImagePermanent()}
                              >
                                <Close
                                  style={{
                                    fontSize: "25px",
                                    fontWeight: "bold",
                                  }}
                                />
                              </IconButton>
                            )}
                          </div>
                        </Col>
                        <Col md="6 mb-3">
                          <h4 className="mb-3">
                            Add Background color in section
                          </h4>
                          <Col md="6 mb-3">
                            <CommonColor
                              color={
                                settingFormData?.[
                                  ".only-text-section.bg-image::before"
                                ]?.["background-color"]
                              }
                              setSettingFormData={setSettingFormData}
                              className={".only-text-section.bg-image::before"}
                              classProperty={"background-color"}
                              label={"Select Background Color"}
                            />
                          </Col>
                        </Col>
                      </Row>
                    </>
                  )}
                </Col>
              </Row>
              <hr />
              <Row className="mt-2">
                <h4 className="mb-3">Make space in Title bottom</h4>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Margin Bottom (Default : 50)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="margin-bottom"
                    type="number"
                    placeholder="Margin Bottom"
                    value={settingFormData?.[
                      ".only-text-section .section-title-area"
                    ]?.["margin-bottom"]?.replace(/px/g, "")}
                    onChange={(e) => handleChangeOnlyTextSectionTitleArea(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
              </Row>
              <hr />
              <Row className="mt-2">
                <h4 className="mb-3">Make change in section subtitle</h4>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Font Size (Default : 16)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="font-size"
                    type="number"
                    placeholder="Font Size"
                    value={settingFormData?.[
                      ".only-text-section .section-title-area .section-subtitle"
                    ]?.["font-size"]?.replace(/px/g, "")}
                    onChange={(e) => handleChangeOnlyTextSectionSubTitle(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Font Weight (Default : 600)"}
                  </Label>
                  <select
                    name="font-weight"
                    id="font-weight"
                    className="form-control"
                    value={
                      settingFormData?.[
                        ".only-text-section .section-title-area .section-subtitle"
                      ]?.["font-weight"]
                    }
                    onChange={(e) => handleChangeOnlyTextSectionSubTitle(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  >
                    <option value="">--select--</option>
                    {fontWeight.map((elem) => {
                      return (
                        <option value={elem["font-weight"]}>
                          {elem["font-weight"]}
                        </option>
                      );
                    })}
                  </select>
                </Col>
                <Col md="4 mb-3">
                  <CommonColor
                    color={
                      settingFormData?.[
                        ".only-text-section .section-title-area .section-subtitle"
                      ]?.["color"]
                    }
                    setSettingFormData={setSettingFormData}
                    className={
                      ".only-text-section .section-title-area .section-subtitle"
                    }
                    classProperty={"color"}
                    label={"Select Color"}
                  />
                </Col>
                <Col md="4 mb-3">
                  <CommonColor
                    color={
                      settingFormData?.[
                        ".only-text-section .section-title-area .section-subtitle"
                      ]?.["background-color"]
                    }
                    setSettingFormData={setSettingFormData}
                    className={
                      ".only-text-section .section-title-area .section-subtitle"
                    }
                    classProperty={"background-color"}
                    label={"Select Background Color"}
                  />
                </Col>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Padding (Default : 5 - 20)"}
                  </Label>
                  <div className="d-flex justify-content-between">
                    <Input
                      className="form-control"
                      name="p1"
                      type="number"
                      placeholder="Padding"
                      value={settingFormData?.[
                        ".only-text-section .section-title-area .section-subtitle"
                      ]?.["p1"]?.replace(/px/g, "")}
                      onChange={(e) => handleChangeOnlyTextSectionSubTitle(e)}
                      style={{ borderRadius: "0", color: "black" }}
                    />
                    <Input
                      className="form-control"
                      name="p2"
                      type="number"
                      placeholder="Padding"
                      value={settingFormData?.[
                        ".only-text-section .section-title-area .section-subtitle"
                      ]?.["p2"]?.replace(/px/g, "")}
                      onChange={(e) => handleChangeOnlyTextSectionSubTitle(e)}
                      style={{ borderRadius: "0", color: "black" }}
                    />
                  </div>
                </Col>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Border Radius (Default : 15)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="border-radius"
                    type="number"
                    placeholder="Border Radius"
                    value={settingFormData?.[
                      ".only-text-section .section-title-area .section-subtitle"
                    ]?.["border-radius"]?.replace(/px/g, "")}
                    onChange={(e) => handleChangeOnlyTextSectionSubTitle(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Margin Bottom (Default : 15)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="margin-bottom"
                    type="number"
                    placeholder="Margin Bottom"
                    value={settingFormData?.[
                      ".only-text-section .section-title-area .section-subtitle"
                    ]?.["margin-bottom"]?.replace(/px/g, "")}
                    onChange={(e) => handleChangeOnlyTextSectionSubTitle(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
              </Row>
              <hr />
              <Row className="mt-2">
                <h4 className="mb-3">Make change in section Title</h4>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Font Size (Default : 44)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="font-size"
                    type="number"
                    placeholder="Font Size"
                    value={settingFormData?.[
                      ".only-text-section .section-title-area .section-title"
                    ]?.["font-size"]?.replace(/px/g, "")}
                    onChange={(e) => handleChangeOnlyTextSectionTitle(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Font Weight (Default : 600)"}
                  </Label>
                  <select
                    name="font-weight"
                    id="font-weight"
                    className="form-control"
                    value={
                      settingFormData?.[
                        ".only-text-section .section-title-area .section-title"
                      ]?.["font-weight"]
                    }
                    onChange={(e) => handleChangeOnlyTextSectionTitle(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  >
                    <option value="">--select--</option>
                    {fontWeight.map((elem) => {
                      return (
                        <option value={elem["font-weight"]}>
                          {elem["font-weight"]}
                        </option>
                      );
                    })}
                  </select>
                </Col>
                <Col md="4 mb-3">
                  <CommonColor
                    color={
                      settingFormData?.[
                        ".only-text-section .section-title-area .section-title"
                      ]?.["color"]
                    }
                    setSettingFormData={setSettingFormData}
                    className={
                      ".only-text-section .section-title-area .section-title"
                    }
                    classProperty={"color"}
                    label={"Select Color"}
                  />
                </Col>
              </Row>
              <hr />
              <Row className="mt-2">
                <h4 className="mb-3">Make change in content paragraph</h4>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Margin Bottom (Default : 20)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="margin-bottom"
                    type="number"
                    placeholder="Margin Bottom"
                    value={settingFormData?.[
                      ".only-text-section .only-text-content p"
                    ]?.["margin-bottom"]?.replace(/px/g, "")}
                    onChange={(e) => handleChangeOnlyTextContentP(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Line Height (Default : 1.6)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="line-height"
                    type="number"
                    placeholder="Line Height"
                    value={
                      settingFormData?.[
                        ".only-text-section .only-text-content p"
                      ]?.["line-height"]
                    }
                    onChange={(e) => handleChangeOnlyTextContentP(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Font Size (Default : 18)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="font-size"
                    type="number"
                    placeholder="Font Size"
                    value={settingFormData?.[
                      ".only-text-section .only-text-content p"
                    ]?.["font-size"]?.replace(/px/g, "")}
                    onChange={(e) => handleChangeOnlyTextContentP(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
              </Row>
              <hr />
              <Row className="mt-2">
                <h4 className="mb-3">
                  Make change in content information list
                </h4>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Margin Bottom (Default : 30)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="margin-bottom"
                    type="number"
                    placeholder="Margin Bottom"
                    value={settingFormData?.[
                      ".only-text-section .only-text-content.info-list"
                    ]?.["margin-bottom"]?.replace(/px/g, "")}
                    onChange={(e) => handleChangeOnlyTextContentInfoList(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
              </Row>
              <hr />
              <Row className="mt-2">
                <h4 className="mb-3">
                  Make change in content information list item
                </h4>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Margin Bottom (Default : 15)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="margin-bottom"
                    type="number"
                    placeholder="Margin Bottom"
                    value={settingFormData?.[
                      ".only-text-section .only-text-content .info-list li"
                    ]?.["margin-bottom"]?.replace(/px/g, "")}
                    onChange={(e) => handleChangeOnlyTextContentInfoListLi(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Font Size (Default : 18)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="font-size"
                    type="number"
                    placeholder="Font Size"
                    value={settingFormData?.[
                      ".only-text-section .only-text-content .info-list li"
                    ]?.["font-size"]?.replace(/px/g, "")}
                    onChange={(e) => handleChangeOnlyTextContentInfoListLi(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
              </Row>
              <hr />
              <Row className="mt-2">
                <h4 className="mb-3">Make change in content order list</h4>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Margin Bottom (Default : 30)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="margin-bottom"
                    type="number"
                    placeholder="Margin Bottom"
                    value={settingFormData?.[
                      ".only-text-section .only-text-content .order-list"
                    ]?.["margin-bottom"]?.replace(/px/g, "")}
                    onChange={(e) => handleChangeOnlyTextContentOrderList(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
              </Row>
              <hr />
              <Row className="mt-2">
                <h4 className="mb-3">Make change in content order list item</h4>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Padding Left (Default : 25)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="padding-left"
                    type="number"
                    placeholder="Padding Left"
                    value={settingFormData?.[
                      ".only-text-section .only-text-content .order-list li"
                    ]?.["padding-left"]?.replace(/px/g, "")}
                    onChange={(e) => handleChangeOnlyTextContentOrderListLi(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Margin Bottom (Default : 15)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="margin-bottom"
                    type="number"
                    placeholder="Margin Bottom"
                    value={settingFormData?.[
                      ".only-text-section .only-text-content .order-list li"
                    ]?.["margin-bottom"]?.replace(/px/g, "")}
                    onChange={(e) => handleChangeOnlyTextContentOrderListLi(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Font Size (Default : 18)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="font-size"
                    type="number"
                    placeholder="Font Size"
                    value={settingFormData?.[
                      ".only-text-section .only-text-content .order-list li"
                    ]?.["font-size"]?.replace(/px/g, "")}
                    onChange={(e) => handleChangeOnlyTextContentOrderListLi(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
              </Row>
              <hr />
              <Row className="mt-2">
                <h4 className="mb-3">
                  Make change in content order list before
                </h4>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Top (Default : 3)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="top"
                    type="number"
                    placeholder="top"
                    value={settingFormData?.[
                      ".only-text-section .only-text-content .order-list li:before"
                    ]?.["top"]?.replace(/px/g, "")}
                    onChange={(e) =>
                      handleChangeOnlyTextContentOrderListLiBefore(e)
                    }
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"font-family (Default : FontAwesome)"}
                  </Label>
                  <select
                    name="font-family"
                    id="font-family"
                    className="form-control"
                    value={
                      settingFormData?.[
                        ".only-text-section .only-text-content .order-list li:before"
                      ]?.["font-family"]
                    }
                    onChange={(e) =>
                      handleChangeOnlyTextContentOrderListLiBefore(e)
                    }
                    style={{ borderRadius: "0", color: "black" }}
                  >
                    <option value="">--select--</option>
                    {fontFamily.map((elem) => {
                      return (
                        <option value={elem["font-family"]}>
                          {elem["font-family"]}
                        </option>
                      );
                    })}
                  </select>
                </Col>
                <Col md="2 mb-3">
                  <CommonColor
                    color={
                      settingFormData?.[
                        ".only-text-section .only-text-content .order-list li:before"
                      ]?.["color"]
                    }
                    setSettingFormData={setSettingFormData}
                    className={
                      ".only-text-section .only-text-content .order-list li:before"
                    }
                    classProperty={"color"}
                    label={"Select Color"}
                  />
                </Col>
              </Row>
              <CustomStyle
                handleChange={handleChangeCustomStyle}
                value={settingFormData?.custom}
              />
            </div>
          </Col>
        </Row>
        <ProductImageUploadPopup
          allPopupState={allPopupState}
          setAllPopupState={setAllPopupState}
          crop={crop}
          setCrop={setCrop}
          completedCrop={completedCrop}
          setCompletedCrop={setCompletedCrop}
          scale={scale}
          rotate={rotate}
          image={settingFormData?.image}
          setImage={setSettingFormData}
          imageUpload={imageUpload}
          isEdit={isEdit}
          reupload={reupload}
          // aspect={1.82 / 1}
        />
      </Container>
    </>
  );
};

export default SettingDetailsPerentPopup;
